import type { ConnectorListResponse } from '@tabbio/types';

export function buildConnectorsPageContextState(
  data: ConnectorListResponse,
  toolsComingSoon = true,
) {
  const entries = [...data.rails.ai, ...data.rails.tool];
  return {
    connectors: entries.map((entry) => ({
      slug: entry.connector.slug,
      name: entry.connector.name,
      rail: entry.connector.rail,
      status:
        entry.connection?.status === 'active'
          ? 'connected'
          : entry.connector.status === 'coming_soon' ||
              (toolsComingSoon && entry.connector.rail === 'tool')
            ? 'coming_soon'
            : 'available',
    })),
  };
}
